import React, { useState, useRef, useEffect } from "react";
import { Redirect, useHistory } from 'react-router-dom';

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Container, Card, Col, Row, Form, Image} from 'react-bootstrap'
import BackgroundSlider from 'react-background-slider'


import img1 from '../../images/bridg/login-bg-1.jpg'
import img2 from '../../images/bridg/login-bg-2.jpg'
import img3 from '../../images/bridg/login-bg-3.jpg'

import { TagPicker } from '@fluentui/react/lib/Pickers';

import sg3 from "../../images/sg3plus.png"
import authService from "../../services/auth.service";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { resetPassword } from "../../actions/auth-action";

import './style.css'
import { DefaultButton, MessageBar, MessageBarType, PrimaryButton } from "@fluentui/react";
import { useDomainListForgotPw } from "../../hooks/useDomainList";
import { __WhiteEmailDomainList } from "../../common/Dictionaries";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { encodeTokenForTransport, isNullUndefinedOrEmpty } from "../../common/Helpers";
import { useSendForgotPasswordCode } from "../../hooks/useOfForgotPassword";
import ReCAPTCHA from "react-google-recaptcha";
import { RECAPTCHA_SITE_KEY } from "../../configurations/paths.config";

  const FORGOT_PASSWORD_CODE_EXPIRATION_SECONDS = 150;

  const ForgotPassword = (props) => {
    
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();

    const form = useRef();
    const checkBtn = useRef(); 
    const txtRefPassword = useRef()
    const txtRefPasswordConfirm = useRef();
    const captchaForgotPasswordRef = useRef(null)
    const previousCodeSendedRef = useRef(false);
    
    const [loading, setLoading] = useState(false);
	  const [loadingResend, setLoadingResend] = useState(false);
    const [emailCodeRemainingSeconds, setEmailCodeRemainingSeconds] = useState(0);
    const [domainList, setDomainList] = useState(null);
    useDomainListForgotPw(domainList, setDomainList);
    const { isLoggedIn } = useSelector(state => state.auth);

    const location = useLocation();
    //const { _loginModel } = location.state || null;
    const _loginModel = location?.state?._loginModel;

    const [forgotPassModel, setForgotPassModel] = useState(
      {
        domain: "",
        username: "",
        email: "",
        emailConfirmation: "",
        emailCode: "",

        password: "",
        passwordConfirmation: "",
        
        codeSended: false,
        recaptchaToken: null
      }
    );
    const [isInValidForgotPassModel, setIsInValidForgotPassModel] = useState(
      {
        domain: false,
        username: false,

        email: false,
        emailMessageError: "",

        emailConfirmation: false,
        emailConfirmationMessageError: "",

        emailCode: false,
        emailCodeMessageError: "",

        password: false,
        passwordMessageError: "",

        passwordConfirmation: false,
        passwordConfirmationMessageError: "",
      }
    );


    const [resetPasswordOk, setResetPasswordOk] = useState(false);
    const [successful, setSuccessful] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
    const { _message } = useSelector(state => state.message);
    const [message, setMessage] = useState(_message);
    const [passwordSecurityFail, setPasswordSecurityFail] = useState(false);
    const [fireSendCode, setFireSendCode] = useState(!isNullUndefinedOrEmpty(_loginModel));
    const isLoading = loading || loadingResend;
    const isEmailCodeFormEnabled = forgotPassModel.codeSended && !resetPasswordOk;
    const isEmailCodeExpired = isEmailCodeFormEnabled && emailCodeRemainingSeconds <= 0;

    const clearMessage = () => {
      setSuccessful(false);
      setMessage("");
    };

    const sanitizeOnlyNumbers = (value) => {
      return String(value ?? '')
        .normalize('NFKC')
        .replace(/[^\d]/g, '')
        .slice(0, 6);
    };

    const startEmailCodeTimer = () => {
      setEmailCodeRemainingSeconds(FORGOT_PASSWORD_CODE_EXPIRATION_SECONDS);
    };

    const stopEmailCodeTimer = () => {
      setEmailCodeRemainingSeconds(0);
    };

    const formatRemainingTime = (totalSeconds) => {
      const safeSeconds = Math.max(totalSeconds, 0);
      const minutes = Math.floor(safeSeconds / 60).toString().padStart(2, '0');
      const seconds = (safeSeconds % 60).toString().padStart(2, '0');

      return `${minutes}:${seconds}`;
    };

    const getEmailCodeExpiredMessage = () => {
      const key = 'data-lang-msg-emailcodeexpired';
      const translated = t(key);

      return translated === key ? 'El código venció. Reenvía un nuevo código.' : translated;
    };

    const getEmailCodeExpiresInLabel = () => {
      const key = 'data-lang-lbl-emailcodeexpiresin';
      const translated = t(key);

      return translated === key ? 'El código vence en' : translated;
    };

    useSendForgotPasswordCode(_loginModel, setForgotPassModel, fireSendCode, setFireSendCode);

    useEffect(() => {
      if (forgotPassModel.codeSended && !previousCodeSendedRef.current && !resetPasswordOk) {
        startEmailCodeTimer();
      }

      previousCodeSendedRef.current = forgotPassModel.codeSended;
    }, [forgotPassModel.codeSended, resetPasswordOk]);

    useEffect(() => {
      if (!forgotPassModel.codeSended || resetPasswordOk || emailCodeRemainingSeconds <= 0 || loading || loadingResend) {
        return undefined;
      }

      const timeoutId = window.setTimeout(() => {
        setEmailCodeRemainingSeconds(prevState => Math.max(prevState - 1, 0));
      }, 1000);

      return () => window.clearTimeout(timeoutId);
    }, [forgotPassModel.codeSended, resetPasswordOk, emailCodeRemainingSeconds, loading, loadingResend]);
    
    const filterSuggestedDomains = (filterText, _domainList) => {
      const _text = filterText
        ? domainList.filter(
            domain => domain.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 && !listContainsDomainList(domain, _domainList),
          )
        : [];
      return _text;
    };
    const listContainsDomainList = (domain, domainList) => {
      if (!domainList?.length || domainList.length === 0) {
        return false;
      }
      return domainList.some(compareDomain => compareDomain.key === domain.key);
    };
    const getTextFromItem = (item) => {
      return item.name;
    };

    const validateEmailAndEmailConfirmation = (_emailText, _emailConfirmationText) => {
      let emailShemaValid = true;
      let emailConfirmationShemaValid = true;
      let returnValue = true;

      let email = null;
      let emailMessageError = null;
      let emailConfirmation = null;
      let emailConfirmationMessageError = null;

      const hasEspecialEmail = __WhiteEmailDomainList.some(elemento => _emailText.includes(elemento));
      if (_emailText !== "") {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(_emailText) === false && !hasEspecialEmail) {
        //if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(_emailText) === false) {
          emailShemaValid = false;
          email = true;
          emailMessageError = t('data-lang-msg-invalid-email');
        }
      }
      else {
        email = true;
        emailMessageError = t('data-lang-msg-required-email');
      }
  
      const hasEspecialEmailConfirmation = __WhiteEmailDomainList.some(elemento => _emailConfirmationText.includes(elemento));
      if (forgotPassModel.emailConfirmation !== "") {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(_emailConfirmationText) === false && !hasEspecialEmailConfirmation) {
        //if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(_emailConfirmationText) === false) {
          emailConfirmationShemaValid = false;
          emailConfirmation = true;
          emailConfirmationMessageError = t('data-lang-msg-invalid-email');
        }
      }
      else {
        emailConfirmation = true;
        emailConfirmationMessageError = t('data-lang-msg-required-emailconfirmation');
      }
  
      if (emailConfirmationShemaValid && emailShemaValid) {
        if (_emailText !== _emailConfirmationText) {
          email = false;
          emailMessageError = "";
          emailConfirmation = true;
          emailConfirmationMessageError = t('data-lang-msg-notsame-emailandconfirmation');

          returnValue = false
        }
      }
      else {
        returnValue = false
      }

      if (returnValue) {
        emailMessageError = "";
        emailConfirmationMessageError = "";
      }

      setIsInValidForgotPassModel(prevState => ({
        ...prevState,
        email: email,
        emailMessageError: emailMessageError,
        emailConfirmation: emailConfirmation,
        emailConfirmationMessageError: emailConfirmationMessageError
      }));

      return returnValue;
    };
    const validateControlEmpty = (value) => {
      return value === "";
    };
    const validatePasswordAndPassowrdConfirmation = (_password, _passwordConfirmation) => {
      let passwordShemaValid = true;
      let passwordConfirmationShemaValid = true;
      let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)(?=.{10,}$)/

      
      if (_password !== "") {
        if (regex.test(_password) === false) {
          passwordShemaValid = false;
          setIsInValidForgotPassModel(prevState => ({
            ...prevState,
            password: true,
            passwordMessageError: t('data-lang-msg-invalid-password')
          }));
          setPasswordSecurityFail(true);
          return (true)
        }
        else {
          setPasswordSecurityFail(false);
        }
      }
      else {
        passwordShemaValid = false;
        setIsInValidForgotPassModel(prevState => ({
          ...prevState,
          password: true,
          passwordMessageError: t('data-lang-msg-required-field')
        }));
      }
  
      if (_passwordConfirmation !== "") {
        if (regex.test(_passwordConfirmation) === false) {
            passwordConfirmationShemaValid = false;
            setIsInValidForgotPassModel(prevState => ({
              ...prevState,
              passwordConfirmation: true,
              passwordConfirmationMessageError: t('data-lang-msg-invalid-password')
            }));
        }
      }
      else {
          passwordConfirmationShemaValid = false;
          setIsInValidForgotPassModel(prevState => ({
            ...prevState,
            passwordConfirmation: true,
            passwordConfirmationMessageError: t('data-lang-msg-required-field')
          }));
      }
  
      if (passwordConfirmationShemaValid && passwordShemaValid) {
        if (_password !== _passwordConfirmation) {
          setIsInValidForgotPassModel(prevState => ({
            ...prevState,
            password: false,
            passwordMessageError: "",

            passwordConfirmation: true,
            passwordConfirmationMessageError: t('data-lang-msg-notsame-passwordandconfirmation')
          }));
          return (true)
        }
        else {
          return (false)
        }
      }
      else {
        return (true)
      }
    };
  


    const onChangeUsername = (e) => {
      clearMessage();

      const _username = e.target.value;
      setIsInValidForgotPassModel(prevState => ({
        ...prevState,
        username: (_username === "")
      }));
      setForgotPassModel(prevState => ({
        ...prevState,
        username: _username
      }));
    };
  
    const onChangeEmail = (e) => {
      clearMessage();

      const _email = e.target.value;
      setIsInValidForgotPassModel(prevState => ({
        ...prevState,
        email: (_email === "")
      }));
      setForgotPassModel(prevState => ({
        ...prevState,
        email: _email
      }));
    };

    const onChangeEmailCode = (e) => {
      clearMessage();

      const _emailCode = sanitizeOnlyNumbers(e.target.value);
      setIsInValidForgotPassModel(prevState => ({
        ...prevState,
        emailCode: (_emailCode === "")
      }));
      setForgotPassModel(prevState => ({
        ...prevState,
        emailCode: _emailCode
      }));
    };

    const onChangeEmailConfirmation = (e) => {
      clearMessage();

      const _emailConfirmation = e.target.value;
      setIsInValidForgotPassModel(prevState => ({
        ...prevState,
        emailConfirmation: (_emailConfirmation === "")
      }));
      setForgotPassModel(prevState => ({
        ...prevState,
        emailConfirmation: _emailConfirmation
      }));
    };

    const onChangePassword = (e) => {
      clearMessage();

      const password = e.target.value;
      setIsInValidForgotPassModel(prevState => ({
        ...prevState,
        password: (password === ""),
      }));
      setForgotPassModel(prevState => ({
        ...prevState,
        password: password,
      }));
    };
    
    const onChangePasswordConfirmation = (e) => {
      clearMessage();

      const passwordConfirmation = e.target.value;
      setIsInValidForgotPassModel(prevState => ({
        ...prevState,
        passwordConfirmation: (passwordConfirmation === "")
      }));     
      setForgotPassModel(prevState => ({
        ...prevState,
        passwordConfirmation: passwordConfirmation
      }));
    };


    
    const handleChangeAutocomplete = (e) => {
      clearMessage();

      if (e.length !== 0) {
        setIsInValidForgotPassModel(prevState => ({
          ...prevState,
          domain: false
        }));
        setForgotPassModel(prevState => ({
          ...prevState,
          domain: e[0].key
        }));
      }
      else {
        setIsInValidForgotPassModel(prevState => ({
          ...prevState,
          domain: true
        }));
        setForgotPassModel(prevState => ({
          ...prevState,
          domain: ""
        }));
      }
    };

    const handleSendCode = (e, setterLoading, messageKey, errorMessageKey) => {
      e.preventDefault();

      if (setterLoading === setLoadingResend && loadingResend) {
        return;
      }

      clearMessage();
      setterLoading(true);

      let _isInvalidUsername = validateControlEmpty(forgotPassModel.username);
      let _isInvalidDomain = validateControlEmpty(forgotPassModel.domain);
      let _isValidEmail = validateEmailAndEmailConfirmation(forgotPassModel.email, forgotPassModel.emailConfirmation);

      if (_isValidEmail && !_isInvalidUsername && !_isInvalidDomain) {
        authService.forgotPassword(forgotPassModel.domain, forgotPassModel.username, forgotPassModel.email, forgotPassModel.emailConfirmation, localStorage.getItem("i18nextLng")).then((response) => {
          if (response.data.succeeded) {
            const selectedUser = _loginModel?.clientUserListAccess?.find(x => x.selected === true);
            const userData = selectedUser?.userName?.split('\\');

            setForgotPassModel(prevState => ({
              ...prevState,
              email: _loginModel?.email || prevState.email,
              emailConfirmation: _loginModel?.email || prevState.emailConfirmation,
              domain: userData && userData.length > 1 ? userData[0] : prevState.domain,
              username: userData && userData.length > 1 ? userData[1] : prevState.username,
              emailCode: "",
              codeSended: true,
            }));

            setIsInValidForgotPassModel(prevState => ({
              ...prevState,
              emailCode: false,
              emailCodeMessageError: "",
            }));

            startEmailCodeTimer();
            setSuccessful(true);
            setMessage(t(messageKey));
          } else {
            setSuccessful(false);
            setMessage(t(response.data.message || errorMessageKey));
          }

          setterLoading(false);
        }).catch((ex) => {
          setterLoading(false);
          setSuccessful(false);
          setMessage(t(errorMessageKey))
        });
      } else {
        setterLoading(false);
        setIsInValidForgotPassModel(prevState => ({
          ...prevState,
          domain: _isInvalidDomain,
          username: _isInvalidUsername
        }));
        setMessage("Error.");
      }
    };

    const handleResetPassword = (e) => {
      e.preventDefault();

      if (loading) {
        return;
      }

      clearMessage();

      if (isEmailCodeExpired) {
        setIsInValidForgotPassModel(prevState => ({
          ...prevState,
          emailCode: true,
          emailCodeMessageError: getEmailCodeExpiredMessage()
        }));

        return;
      }

      const _isInvalidEmailCode = validateControlEmpty(forgotPassModel.emailCode);
      let _isInvalidPassword = validatePasswordAndPassowrdConfirmation(forgotPassModel.password, forgotPassModel.passwordConfirmation);

      setIsInValidForgotPassModel(prevState => ({
        ...prevState,
        emailCode: _isInvalidEmailCode,
        emailCodeMessageError: _isInvalidEmailCode ? t('data-lang-msg-required') : ""
      }));

      if (_isInvalidEmailCode || _isInvalidPassword) {
        if (passwordSecurityFail) {
          setMessage(t('data-lang-msg-passwordsecurityfail'));
        }
        else {
          setMessage("Error.");
        }

        return;
      }

      const token = captchaForgotPasswordRef.current && captchaForgotPasswordRef.current.getValue ? captchaForgotPasswordRef.current.getValue() : null;

      if (isNullUndefinedOrEmpty(token)) {
        setSuccessful(false);
        setMessage(t('data-lang-msg-select-recaptcha'));
        return;
      }

      setLoading(true);

      const modelToReset = {
        ...forgotPassModel,
        recaptchaToken: encodeTokenForTransport(token)
      };

      dispatch(resetPassword(modelToReset)).then(() => {
        stopEmailCodeTimer();
        setResetPasswordOk(true);
        setSuccessful(true);
        setMessage(t('data-lang-msg-passwordretrieve-changed-success'));
      })
      .catch(() => {
        setSuccessful(false);
        setMessage(t('data-lang-msg-passwordretrieve-changed-fail'));
      })
      .finally(() => {
        setLoading(false);
      });
    };

    const handleShowHidePassword = (e) => {
      if (e === "pass") {
        setShowPassword(!showPassword);
      }
      if (e === "passConfirm") {
        setShowPasswordConfirm(!showPasswordConfirm);
      }
    };

    if (isLoggedIn) {
      return <Redirect to="/profile" />;
    }
    else if (isNullUndefinedOrEmpty(_loginModel)) {
      return <Redirect to="/" />;
    }
    
    return (
        <>     
          <BackgroundSlider
            images={[img1, img2, img3]}
            duration={10} transition={2} />
          <Container style={{marginTop: "200px"}} className="col-xl-5 login-bg">
            <MessageBar
              styles={{root:{marginTop: "-96px !important"}}}
              messageBarType={MessageBarType.warning} >
              <div>
                <b>{t('data-lang-msg-warning')}:</b><br/>
                <ul>
                  <li>
                    {t('data-lang-msg-password-policy-1')}
                  </li>
                  <li>
                    {t('data-lang-msg-password-policy-2')}
                  </li>
                  <li>
                    {t('data-lang-msg-password-policy-3')}
                  </li>
                  <li>
                    {t('data-lang-msg-password-policy-4')}
                  </li> 
                  <li>
                    {t('data-lang-msg-password-policy-5')}
                  </li> 
                </ul>                
              </div>
            </MessageBar>
            <Card className="cardforgot-container">
              <div className="profile-img-card">
                <Image
                  src={sg3}
                  alt="profile-img"
                />
              </div>
              <Form ref={form}>
                <fieldset >
                  <div>
                    {
                      !isNullUndefinedOrEmpty(_loginModel.clientUserListAccess) && _loginModel.clientUserListAccess.length > 0 &&
                      <div className="border pointer">
                        <Card.Body className="p-1">
                          <Row>
                            <Col>{_loginModel.clientUserListAccess.find(x => x.selected === true).userName}</Col>
                            <Col className="col-auto me-auto">
                              <input type="radio" name="accountRadio" className="pointer" disabled={true} checked={true} />
                            </Col>
                          </Row>
                        </Card.Body>
                      </div>
                    }
                  </div>
                  {
                    forgotPassModel.codeSended && !resetPasswordOk &&
                    <>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label htmlFor="emailcode">{t('data-lang-lbl-emailcode')}</Form.Label>
                              <Form.Control
                                id="txtEmailCode"
                                name="emailCode"
                                type="text"
                                className="form-control"
                                value={forgotPassModel.emailCode}
                                onChange={onChangeEmailCode}
                                isInvalid={isInValidForgotPassModel.emailCode !== null ? isInValidForgotPassModel.emailCode : false}
                                autoComplete="one-time-code"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                maxLength={6}
                                disabled={isEmailCodeExpired || loading || loadingResend}
                                placeholder="" required={true} /> 
                                {
                                  isInValidForgotPassModel.emailCode === true &&
                                  <div className="invalid-feedback">
                                    {isInValidForgotPassModel.emailCodeMessageError}
                                  </div>
                                }
                                <div className={isEmailCodeExpired ? "text-danger small mt-1" : "text-muted small mt-1"}>
                                  {
                                    isEmailCodeExpired
                                    ? getEmailCodeExpiredMessage()
                                    : `${getEmailCodeExpiresInLabel()}: ${formatRemainingTime(emailCodeRemainingSeconds)}`
                                  }
                                </div>
                            </Form.Group>

                          </Col>
                        </Row>
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Row>
                          <Col>
                            <Form.Group className="mb-3">
                              <Row>
                                <Col>
                                  <Form.Group className="mb-3">
                                    <Form.Label htmlFor="password">{t('data-lang-lbl-newpassword')}</Form.Label>
                                    <div className="input-group mb-3">
                                      <Form.Control
                                        id="txtPassword"
                                        ref={txtRefPassword}
                                        name="password"
                                        type={showPassword ? "text" : "password"}
                                        className="form-control"
                                        value={forgotPassModel.password}
                                        onChange={onChangePassword}
                                        isInvalid={isInValidForgotPassModel.password !== null ? isInValidForgotPassModel.password : false}
                                        disabled={loading || loadingResend}
                                        placeholder="" required={true} /> 
                                      <div className="input-group-text" onKeyDown={() => handleShowHidePassword("pass")} onClick={() => handleShowHidePassword("pass")} role="button" tabIndex="-1">
                                        {!showPassword && <AiOutlineEyeInvisible />}
                                        {showPassword && <AiOutlineEye />}
                                      </div>
                                      {
                                        isInValidForgotPassModel.password === true &&
                                        <div className="invalid-feedback">
                                          {isInValidForgotPassModel.passwordMessageError}
                                        </div>
                                      } 
                                    </div>
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Form.Group>
                            <Form.Group className="mb-3">
                              <Row>
                                <Col>
                                  <Form.Group className="mb-3">
                                    <Form.Label htmlFor="passwordconfirmation">{t('data-lang-lbl-passwordconfirmation')}</Form.Label>
                                    <div className="input-group mb-3">
                                      <Form.Control
                                        id="txtPasswordConfirmation"
                                        ref={txtRefPasswordConfirm}
                                        name="passwordConfirmation"
                                        type={showPasswordConfirm ? "text" : "password"}
                                        className="form-control"
                                        value={forgotPassModel.passwordConfirmation}
                                        onChange={onChangePasswordConfirmation}
                                        isInvalid={isInValidForgotPassModel.passwordConfirmation !== null ? isInValidForgotPassModel.passwordConfirmation : false}
                                        placeholder="" required={true} />
                                        <div className="input-group-text" onKeyDown={() => handleShowHidePassword("passConfirm")} onClick={() => handleShowHidePassword("passConfirm")} role="button" tabIndex="0" >
                                          {!showPasswordConfirm && <AiOutlineEyeInvisible />}
                                          {showPasswordConfirm && <AiOutlineEye />}
                                        </div>
                                        {
                                          isInValidForgotPassModel.passwordConfirmation === true &&
                                          <div className="invalid-feedback">
                                            {isInValidForgotPassModel.passwordConfirmationMessageError}
                                          </div>
                                        }
                                      </div>
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Form.Group>
                            <Form.Group className="mb-12">
                              <Row>
                                <Col xl={12} className="recaptcha-segment">
                                  <ReCAPTCHA sitekey={RECAPTCHA_SITE_KEY} ref={captchaForgotPasswordRef} />
                                </Col>
                              </Row>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Form.Group>
                    </>
                  }
                  <Form.Group className="mb-3 text-end">
                    <Row className="mb-3 text-end row justify-content-end">
                      <DefaultButton className="w-100 text-center m-1"  onClick={history.goBack} disabled={isLoading} >
                        <span> {t('data-lang-btn-goback')} </span>
                      </DefaultButton>
                      {!forgotPassModel.codeSended && (
                        <Card className="me-1">
                          <div className="d-flex">
                            <span className="spinner-border spinner-border-sm my-auto mx-auto"></span>
                            <span className="mx-auto"> {t('data-lang-btn-sendingcode')} </span>
                          </div>
                        </Card>
                      )}                      
                      {forgotPassModel.codeSended && !resetPasswordOk && (
                        <>
                          <PrimaryButton className="w-100 text-center m-1" onClick={ (e) => handleResetPassword(e) } disabled={loading || loadingResend || isEmailCodeExpired} >
                              { loading && (<span className="spinner-border spinner-border-sm"></span>) }
                              <span> { t('data-lang-btn-resetpassword') } </span>
                          </PrimaryButton>
                          <DefaultButton className="w-100 text-center m-1" onClick={ (e) => handleSendCode(e, setLoadingResend, "data-lang-msg-resentcode", 'data-lang-msg-internalerror') } disabled={loadingResend || loading} >
                              { loadingResend && (<span className="spinner-border spinner-border-sm"></span>) }
                              <span> { t('data-lang-btn-resentcode') } </span>
                          </DefaultButton>
                        </>
                      )}
                    </Row>
                  </Form.Group>
                  {((!successful && message) || successful) && (
                    <div className="form-group">
                      <div className={ successful ? "alert alert-success" : "alert alert-danger" } role="alert">
                        {message}
                      </div>
                    </div>
                  )}
                  <Form.Check style={{ display: "none" }} ref={checkBtn} />
                </fieldset>
              </Form>
            </Card>
          </Container>
        </>
    );
  };
    
  export default ForgotPassword;